import React from "react";
import DatePicker from "react-datepicker";
import { StyledLabel, StyledRequired, Error, Hint } from "./styles";

// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";

const SDatePicker = styled.div`
    .react-datepicker-wrapper {
        input {
            border: 0;
            font-size: 16px;
            color: hsl(0, 0%, 20%);
            font-weight: 400;
            width: 100%;
            outline: none;
            border: 1px solid #9a9c9f;
            border-radius: 6px;
            padding: 9px;
            :disabled {
                border: none;
                background-color: transparent;
                padding: 0;
            }
        }
    }

    .react-datepicker__time-container {
        padding: 0;
    }
    .react-datepicker__current-month,
    .react-datepicker-time__header {
        display: block;
        padding: 10px;
    }
    .react-datepicker__navigation--next,
    .react-datepicker__navigation--previous {
        visibility: visible !important;
        top: ${(props) => (props.children.props.showYearPicker ? "6px !important" : "")};
        .react-datepicker__navigation-icon--next,
        .react-datepicker__navigation-icon--previous {
            display: none;
        }
    }
`;
function DatePickerInput({
    selectedValue,
    name,
    onChange,
    required,
    label,
    dateFormat,
    error,
    isEditable,
    placeHolder,
    showYearPicker,
    maxDate,
    minDate,
}) {
    return (
        <div style={{ width: "100%" }}>
            <StyledLabel>
                {label} {required && <StyledRequired>*</StyledRequired>}
            </StyledLabel>
            <SDatePicker>
                {showYearPicker ? (
                    <DatePicker
                        selected={selectedValue}
                        onChange={onChange}
                        showYearPicker={showYearPicker}
                        dateFormat="yyyy"
                        placeholderText={placeHolder}
                        maxDate={maxDate}
                        minDate={minDate}
                        disabled={!isEditable}
                    />
                ) : (
                    <DatePicker
                        disabled={!isEditable}
                        renderCustomHeader={({
                            monthDate,
                            customHeaderCount,
                            decreaseMonth,
                            increaseMonth,
                        }) => (
                            <div>
                                <button
                                    aria-label="Previous Month"
                                    className="react-datepicker__navigation react-datepicker__navigation--previous"
                                    style={
                                        customHeaderCount === 1 ? { visibility: "hidden" } : null
                                    }
                                    type="button"
                                    onClick={decreaseMonth}
                                >
                                    <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
                                        {"<"}
                                    </span>
                                </button>
                                <span className="react-datepicker__current-month">
                                    {monthDate.toLocaleString("en-US", {
                                        month: "long",
                                        year: "numeric",
                                    })}
                                </span>
                                <button
                                    aria-label="Next Month"
                                    className="react-datepicker__navigation react-datepicker__navigation--next"
                                    style={
                                        customHeaderCount === 0 ? { visibility: "hidden" } : null
                                    }
                                    type="button"
                                    onClick={increaseMonth}
                                >
                                    <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
                                        {">"}
                                    </span>
                                </button>
                            </div>
                        )}
                        selected={selectedValue}
                        onChange={onChange}
                        dateFormat={dateFormat}
                        name={name}
                        showTimeSelect
                        className={isEditable ? "" : "isEditableStyle"}
                        required={required}
                        placeholderText={placeHolder}
                        showYearPicker={showYearPicker}
                        maxDate={maxDate}
                        minDate={minDate}
                    />
                )}
            </SDatePicker>
            <Hint>{error && required && <Error>Please fill this field </Error>}</Hint>
        </div>
    );
}

export default DatePickerInput;
